import { render } from "./WelcomePage.vue?vue&type=template&id=daa19324&scoped=true"
const script = {}

import "./WelcomePage.vue?vue&type=style&index=0&id=daa19324&scoped=true&lang=css"

import exportComponent from "C:\\Users\\c.turnbull.VT\\Documents\\GitHub\\vars-portal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-daa19324"]])

export default __exports__